interface ILessonInfoProps {
  module: string;
  numberLesson: number;
  title: string;
  scheduledAt: string | null;
  endDate: string | null;
  moduleTeacher: null;
  lecturer: null;
}

export const LessonInfo = (props: ILessonInfoProps) => {
  const { module, scheduledAt, numberLesson, title } = props;
  const formattedScheduledAt = scheduledAt
    ? new Date(scheduledAt).toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
    : null;

  return (
    <div className="bg-red p-6 rounded-2xl">
      <div className="text-[#EFBBBB] inline-flex items-center gap-x-2">
        <p>{module}</p>
        {formattedScheduledAt && <p>{formattedScheduledAt.replace(',', '')}</p>}
      </div>
      <h2 className="text-white text-[32px] font-medium mb-4">
        {numberLesson}. {title}
      </h2>
    </div>
  );
};
